import type {LoaderFunctionArgs} from "@remix-run/node";
import {ArticleRoute, articleMeta} from "@/components/article/articleRoute";
import {loadArticle} from "@/components/article/articleRoute.server";
import {ARTICULO} from "@/constants/index";
import {clientLoaderWithTexts} from "@/utils/markdown/clientLoader";

// Reached by a click, the page gets its data from the server loader and the compiler for its texts together
export const clientLoader = clientLoaderWithTexts;

export const loader = (args: LoaderFunctionArgs) => loadArticle(args, ARTICULO);
export const meta = articleMeta;
export default ArticleRoute;
